import { deepClone } from "@mui/x-data-grid/utils/utils";
import { defaultUpdateAccessConfig } from "../features/manageUpdateAccess/manageUpdateAccessConfig";
import { ChannelkartNetworkGet } from "./networkService";

export async function fetchUpdateAccessConfig(configName: string){
    const url = '/metadata/clientconfig';
    try{
        const response = await ChannelkartNetworkGet(url);
        const config = response.data.features.find((Obj: { domainType: string }) => {
            return Obj.domainType === configName;
        })
        return config?.domainValues ?? deepClone(defaultUpdateAccessConfig);
        
    }catch(err){
        console.log(err);
        return [];
    }   
}
export async function fetchNewUpdateAccessConfig(configName: string){
    const url = '/metadata/otpverify';
    try{
        const response = await ChannelkartNetworkGet(url);
        const config = response.data.features.find((Obj: { domainType: string }) => {
            return Obj.domainType === configName;
        })
        return config?.domainValues ?? deepClone(defaultUpdateAccessConfig);
        
    }catch(err){
        console.log(err);
        return [];
    }   
}